import React from 'react';
import Head from 'next/head';

const title = 'Wedding Website Templates & Designs';
const description =
  'Create a beautiful wedding website in minutes for free. Personalize with over 1000 customizable templates & designs. Add RSVPs and share your site instantly.';

const WebsiteDesignsPLPMeta = (): JSX.Element => (
  <Head>
    <title>{title}</title>
    <meta name="description" content={description} />

    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta
      property="og:image"
      content="https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/favicon-rebrand/apple-touch-icon.png"
    />
    <meta name="twitter:site" content="@zola" />
    <meta name="twitter:card" content="summary" />
    <link rel="canonical" href="https://www.zola.com/wedding-planning/website/designs" />
  </Head>
);

export default WebsiteDesignsPLPMeta;
